import React from 'react';
import { makeStyles } from 'tss-react/mui';
import {Button} from '@mui/material';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import {agentDeveloperUtils} from 'wobi-web-common';

const useStyles = makeStyles()((theme) => ({
  button: {
    '&:hover': {
      backgroundColor: agentDeveloperUtils.getSecondaryColor(300),
      color: theme.palette.primary.contrastText,
      scale: 1.1,
      shadow: '0px 0px 10px 0 rgb(0 0 0 / 20%)',
    },
    [theme.breakpoints.down('sm')]: {
      alignSelf: 'center',
      width: '50%',
    },
    alignSelf: 'center',
    backgroundColor: agentDeveloperUtils.getSecondaryColor(200),
    color: theme.palette.primary.contrastText,
    flex: 2,
    height: 'fit-content',
  },
  closeButton: {
    '&:hover': {
      color: theme.palette.text.primary,
      scale: 1.1,
      shadow: '0px 0px 10px 0 rgb(0 0 0 / 20%)',
    },
    color: theme.palette.text.secondary,
    cursor: 'pointer',
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 700,
    MozUserSelect: 'none',
    msUserSelect: 'none',
    padding: '0 10px',
    position: 'absolute',

    right: 20,

    top: 10,

    // i want that if then use try to select the text it will not be selected
    userSelect: 'none',
    WebkitTapHighlightColor: 'transparent',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    zIndex: 1001,

  },
  footerContainer: {
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper,
    bottom: 0,
    boxShadow: '0px -2px 20px 0 rgb(0 0 0 / 40%)',
    display: 'flex',
    height: '150px',
    justifyContent: 'space-between',
    padding: '10px 20px',
    position: 'fixed',
    right: 0,
    width: '100%',
    zIndex: 1000,
  },
  footerContainerData: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.up('xl')]: {
      flexDirection: 'row',
    },
  },
  logo: {
    height: 'auto',
    width: '100px',
  },
  message: {
    // mobile size change the font size
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(20),
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(15),
    },
    color: theme.palette.text.primary,
    flex: 8,
    fontSize: theme.typography.pxToRem(25),
    fontWeight: 500,
  },
}));

const BannerFooter = ({handleButtonClick, logo, text, buttonText, handleClose}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.footerContainer}>
      <span
        className={classes.closeButton}
        role='button'
        tabIndex={0}
        onClick={handleClose}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleClose(e);
          }
        }}
        aria-label='Close'
      >
      x
      </span>
      <img className={classes.logo} src={logo} alt='Company Logo' />
      <div className={classes.footerContainerData}>
        <span className={classes.message}>
          <FormattedMessage id={text} defaultMessage='דברו איתי' />
        </span>
        <Button className={classes.button} onClick={handleButtonClick}>
          <FormattedMessage id={buttonText} defaultMessage='דברו איתי' />
        </Button>

      </div>
    </div>
  );
};
BannerFooter.propTypes = {
  buttonText: PropTypes.string.isRequired,
  handleButtonClick: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  logo: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default BannerFooter;
